import { wsConstants } from '../_constants';

export const wsActions = {
  connect,
  connected,
  disconnect,
  disconnected,
  receive,
  send,
  pending,
};

function connect(host, id, connectTimeout) {
  return { type: wsConstants.CONNECT, host, id, connectTimeout };
}

function connected(host) {
  return { type: wsConstants.CONNECTED, host };
}

function disconnect() {
  return { type: wsConstants.DISCONNECT };
}

function disconnected() {
  return { type: wsConstants.DISCONNECTED };
}

// `id` is the scan the message is about; `receivedAt` dates the presigned
// links it carries, which the generator signs just before sending.
function receive(msg, id, receivedAt = Date.now()) {
  return { type: wsConstants.RECEIVE, msg, id, receivedAt };
}

function send(msg, makerTimeout) {
  return { type: wsConstants.SEND, msg, makerTimeout };
}

function pending(id) {
  return { type: wsConstants.PENDING, id };
}